/**
 * @atlas
 * @kind helper
 * @partOf primitive:ui, primitive:websockets
 * @uses primitive:shared
 */
import type { QueryClient } from '@tanstack/react-query';
import type { WSEvent } from '@zealot/shared/ws';

// gloss
const handlers = {
  query: {
    refetch: (queryClient: QueryClient, event: WSEvent) => {
      queryClient.invalidateQueries({ queryKey: [event.key] });
    },
  },
};

export const dispatchMessage = (queryClient: QueryClient, event: WSEvent): void => {
  handlers[event.category]?.[event.action]?.(queryClient, event);
};
